/** Hook to handle persistence of the scores, either in Tunasong storage, or local storage */

import { graphHooks } from '@tunasong/graph-lib/react'
import { isPersisted, type Game, type GameResult } from '@tunasong/schemas'
import invariant from 'tiny-invariant'

/** Hook to use score persistence with entities */
export const useScorePersistEntity = ({
  game,
  userName,
  userId,
}: {
  game: Game
  userName: string
  userId?: string
}) => {
  const persistedGame = isPersisted(game) ? game : undefined
  const { createEntity } = graphHooks.useEntityCreate()

  const { entities: gameResults = [] } = graphHooks.useEntityChildren<GameResult>({
    parentId: game.id,
    filter: 'gameresult',
    skip: !userId,
  })
  const userGameResults = gameResults.filter(result => result.userId === userId)

  const handleSaveScore = (score: number) => {
    invariant(persistedGame, 'Game not persisted')
    createEntity({
      entity: {
        type: 'gameresult',
        score,
        nickName: userName,
        createdAt: new Date().toISOString(),
      } satisfies GameResult,
      parent: persistedGame,
    })
  }
  return { saveScore: handleSaveScore, gameResults, userGameResults }
}
